<!--
    TODO: A11Y combobox
    https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
    https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/combobox_role
-->
<div class="sir-container" #container tabindex="-1">
    <div class="sir-menu-top sir-text-style-paragraph-l-bold">
        <div>
            @if (level) {
                <sirius-icon
                    class="sir-arrow"
                    [name]="'caret_left'"
                    (click)="previous()"
                    data-cy="filterMenuPrevious-icon"></sirius-icon>
                <span>{{ selectedItem.name }}</span>
            } @else {
                <sirius-icon [name]="'funnel_simple'" data-cy="filterMenuHome-icon"></sirius-icon>
                <span>{{ 'button.filters' | translate }}</span>
            }
        </div>
        <sirius-icon [name]="'x'" (click)="closeMenu()" data-cy="closeFilterMenu-icon"></sirius-icon>
    </div>
    <div class="sir-menu-body sir-text-style-paragraph-s-default">
        <ul class="sir-items" data-cy="filterOptions-list">
            @if (level === 0) {
                @for (item of filters; track $index) {
                    <li>
                        <button
                            type="button"
                            class="sir-item-container"
                            (click)="next(item, $index)"
                            data-cy="filterOption-main">
                            <span class="sir-text-container">
                                <span class="sir-text" data-cy="mainFilterOption-name">
                                    {{ item.name }}
                                </span>
                                <span class="sir-text-ghost" aria-hidden="true">
                                    {{ item.name }}
                                </span>
                            </span>
                            <span class="sir-icon-container">
                                @if (item.activeCount) {
                                    <sirius-badge
                                        [count]="item.activeCount"
                                        data-cy="selectedFilter-count"></sirius-badge>
                                }
                                <sirius-icon
                                    class="sir-icon"
                                    [name]="'caret_right_small'"
                                    data-cy="subFilterOptionNavigation-icon"></sirius-icon>
                            </span>
                        </button>
                    </li>
                }
            }
            @if (level > 0) {
                @for (item of selectedItem.values; track $index) {
                    <li>
                        <button
                            type="button"
                            class="sir-item-container"
                            (click)="toggleActive($index)"
                            [ngClass]="{ 'sir-active': isActive($index) }"
                            [attr.aria-pressed]="isActive($index)"
                            data-cy="filterOption-sub">
                            <span class="sir-text-container">
                                <span class="sir-text" data-cy="subFilterOption-name">
                                    {{ item.name }}
                                </span>
                                <span class="sir-text-ghost" aria-hidden="true">
                                    {{ item.name }}
                                </span>
                            </span>
                            <span class="sir-icon">
                                <sirius-icon [name]="'check'" data-cy="filterOptionSelected-icon"></sirius-icon>
                            </span>
                        </button>
                    </li>
                }
            }
        </ul>
    </div>
    <div class="sir-buttons">
        @if (level) {
            <button
                siriusButton
                [buttonType]="'linkstyle'"
                [buttonText]="'button.clear' | translate"
                (click)="this.clearSubItems()"
                data-cy="clearAllSelectedSubFilters-button"></button>
        } @else {
            <button
                siriusButton
                [buttonType]="'linkstyle'"
                [buttonText]="'button.clearAll' | translate"
                (click)="this.clearCategories()"
                data-cy="clearAllSelectedFilters-button"></button>
        }
        <button
            siriusButton
            [buttonType]="'primary'"
            [buttonText]="'button.save' | translate"
            (click)="closeMenu()"
            data-cy="saveSelectedFilters-button"></button>
    </div>
</div>
